module.exports = __webpack_public_path__ + "static/media/Alien (Series 21).33348cdc.jpg";